import axios from '@axios'

export default {
  loadTable(queryFilter) {
    let queryUrl = ''
    queryUrl = `?page=${queryFilter.page - 1}&size=${queryFilter.size}&sort=${queryFilter.sort},${queryFilter.order}`
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`
    }
    return axios.get(`/core/naturezas_fiscais${queryUrl}`)
  },
  insertNewfiscalNarure(data) {
    return axios.post('/core/naturezas_fiscais', data)
  },
  editFiscalNature(data) {
    return axios.put(`/core/naturezas_fiscais/${data.id}`, data)
  },
  deleteFiscalNature(id) {
    return axios.delete(`/core/naturezas_fiscais/${id}`)
  },
}
